<template>
  <div class="header__wrapper-client client__header">
    <slot name="logo" />

    <div class="header__choose-game">
      <button
        class="button button-additional-gradient header__button"
        @click="catalogClickHandler">
        <span>
          Choose a game
        </span>
        <arrowhead-icon
          v-if="!isMobile"
          :is-reverse="isGameMenuOpened"
          class="header__button-icon" />
      </button>
    </div>

    <div class="header__buttons">
      <router-link
        :to="{ name: 'client__orders' }"
        class="button button-main header__button header__button--catalog">
        My Orders
      </router-link>
    </div>

    <div class="header__account">
      <header-select-widget
        :items="filteredAccountLinks"
        :value="filteredAccountLinks[0]"
        :open-triggers="['hover']"
        type="account-cashback"
        should-hide-selected-value
        @select-item="$event.callback && $event.callback()"
        @open="$emit('hideSidebar')" />
    </div>

    <div
      v-if="!isPlatformApp"
      class="header__burger">
      <slot name="burger" />
    </div>

    <slot
      v-if="!isMobile"
      name="pc-game-menu" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ArrowheadIcon from 'Components/ui/Icons/ArrowheadIcon.vue';
import HeaderSelectWidget from 'Components/MainHeader/HeaderSelectWidget.vue';

export default {
  name: 'ClientHeaderTemplate',

  components: {
    ArrowheadIcon,
    HeaderSelectWidget,
  },

  props: {
    isGameMenuOpened: {
      type: Boolean,
      default: false,
    },

    user: {
      type: Object,
      required: true,
    },

    isMobile: {
      type: Boolean,
      default: true,
    },

    filteredAccountLinks: {
      type: Array,
      default: () => ([]),
    },
  },

  computed: {
    ...mapGetters(['isPlatformApp']),

    welcomeMessage() {
      return this.user?.username ? `Hello, ${this.user.username}` : 'You are welcome!';
    },
  },

  methods: {
    catalogClickHandler() {
      if (this.isMobile) {
        this.$router.push({ name: 'root' });
        return;
      }

      this.$emit('setGameMenuState', !this.isGameMenuOpened);
    },
  },
};
</script>

<style lang="scss" scoped>
  .header__wrapper-client {
    grid-template-areas: 'logo account burger';
    grid-template-columns: 1fr auto max-content;
    padding-top: 8px;
    padding-bottom: 8px;
  }

  .header__welcome {
    grid-area: welcome;
    display: none;
  }

  .header__buttons,
  .header__account {
    display: grid;
    grid-gap: 16px;
    grid-auto-flow: column;
    align-items: center;
  }

  .header__button {
    display: flex;
    align-items: center;
    padding: 10px;
    font-size: $text-13px;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    height: 40px;

    &--catalog {
      padding: 8px 12px;
      background-image: linear-gradient(270deg,
              $color--basic-green 0%, $color--basic-green 50%, $color--basic-lime 100%);
      background-size: 200% 100%;
      background-position: 0 0;
      transition: background-position 0.2s;

      &:hover {
        background-position: 100% 0;
      }
    }
  }

  .header__button-icon {
    width: 24px;
    height: 24px;
    margin-left: 10px;
  }

  .header__account {
    margin-left: 0;
    margin-right: -13px;
  }

  /deep/ .ui-select__head-content {
    gap: 10px;
  }

  @media screen and #{$screen-more-or-640} {
    .header__wrapper-client {
      grid-template-areas: 'logo buttons account burger';
      grid-template-columns: 1fr auto auto max-content;
    }

    .header__wrapper-client, .header__buttons {
      grid-gap: 24px;
    }
  }

  @media screen and #{$screen-less-than-1024} {
    .header__buttons, .header__choose-game {
      display: none;
    }
  }

  @media screen and #{$screen-more-or-1024} {
    .header__wrapper-client {
      grid-template-areas: 'logo welcome buttons account';
      grid-template-columns: max-content 1fr auto auto;
    }

    .header__welcome {
      display: block;
      margin: 0 40px;
      font-size: $text-19px;
      font-weight: 500;
      flex: 1 1 auto;
    }

    .header__burger {
      display: none;
    }
  }
</style>
